'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import AppCardNew from './AppCardNew';

const AppCard = props => {
  const {
    certifiedAt,
    className,
    companyName,
    hubInstalls,
    iconUrl,
    installed,
    installsCount,
    name,
    showIsNewApp,
    tagline
  } = props;
  return /*#__PURE__*/_jsx(AppCardNew, {
    appName: name,
    className: className,
    companyName: companyName,
    hubspotCertified: !!certifiedAt,
    iconUrl: iconUrl,
    installed: installed,
    installsCount: installsCount != null ? installsCount : hubInstalls,
    showIsNewApp: showIsNewApp,
    tagline: tagline
  });
};

AppCard.propTypes = {
  certifiedAt: PropTypes.number,
  className: PropTypes.string,
  companyName: PropTypes.string,
  hubInstalls: PropTypes.number,
  iconUrl: PropTypes.string.isRequired,
  installed: PropTypes.bool,
  installsCount: PropTypes.number,
  name: PropTypes.string.isRequired,
  showIsNewApp: PropTypes.bool,
  tagline: PropTypes.string
};
AppCard.defaultProps = {
  installed: false,
  showIsNewApp: false,
  tagline: ''
};
export default AppCard;